import { render, staticRenderFns } from "./Receiver.vue?vue&type=template&id=0d652e0d&scoped=true&"
import script from "./Receiver.vue?vue&type=script&lang=js&"
export * from "./Receiver.vue?vue&type=script&lang=js&"
import style0 from "./Receiver.vue?vue&type=style&index=0&id=0d652e0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d652e0d",
  null
  
)

export default component.exports